import type {
  ServiceGetAllResponse,
  ServiceQueryOptionType
} from '@/types/service'

import { api, handleAxiosError } from '@/lib/axios'

import type { PoktanResponseData } from './types'

const LIST_POKTAN_QUERY_KEY = (key?: string | Record<string, any>) =>
  ['list_poktan', key] as const

const getAll = (
  params: Partial<{
    per_page: number
    page: number
    search: string
    province_code: string
    city_code: string
    district_code: string
    village_code: string
    poktan_program_id: string
    poktan_status: 'active' | 'inactive'
    poktan_usaha_id: string
    poktan_type_id: string
    poktan_class_id: string
  }>
): ServiceQueryOptionType<ServiceGetAllResponse<PoktanResponseData[]>> => ({
  queryKey: LIST_POKTAN_QUERY_KEY(params),
  queryFn: async () => {
    try {
      const q = {
        per_page: params.per_page || 10,
        page: params.page || 1,
        search: (params.search ?? '').length > 2 ? params.search : undefined,
        province_code:
          (params.province_code ?? '').length > 0
            ? params.province_code
            : undefined,
        city_code:
          (params.city_code ?? '').length > 0 ? params.city_code : undefined,
        district_code:
          (params.district_code ?? '').length > 0
            ? params.district_code
            : undefined,
        village_code:
          (params.village_code ?? '').length > 0
            ? params.village_code
            : undefined,
        program:
          (params.poktan_program_id ?? '').length > 0
            ? params.poktan_program_id
            : undefined,
        status: !params.poktan_status
          ? undefined
          : params.poktan_status === 'active'
            ? 'Aktif'
            : 'Tidak Aktif',
        usaha:
          (params.poktan_usaha_id ?? '').length > 0
            ? params.poktan_usaha_id
            : undefined,
        type:
          (params.poktan_type_id ?? '').length > 0
            ? params.poktan_type_id
            : undefined,
        class:
          (params.poktan_class_id ?? '').length > 0
            ? params.poktan_class_id
            : undefined
      }

      const response = await api.get<
        ServiceGetAllResponse<PoktanResponseData[]>
      >('/report/extension-personnel-main/list-poktan', {
        params: q
      })

      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

export const listPoktan = {
  queryKey: LIST_POKTAN_QUERY_KEY,
  getAll
}
